<template>
  <div >
      <div class="swiper">
      <div class="toptexts">
        <div class="imgtitle">{{detail.Name}}</div>
        <div class="texts">{{detail.Summary}}</div>
      </div>
    </div>
    <div class="width1200" v-html="detail.Content"></div>
  </div>
</template>
<style lang="scss" scoped>
    /* 大屏 宽度大于768 */
    @media (min-width: 768px) {
        .width1200 {
            width: 1200px;
            margin: 40px auto;
            min-height: 1150px;
        }

        .swiper {
            width: 100%;
            height: 314px;
            background-image: url(../img/three_1.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            position: relative;

            .toptexts {
                width: 736px;
                position: absolute;
                top: 28%;
                margin: 0 auto;
                left: 50%;
                margin-left: -368px;
                font-size: 20px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                color: #fff;
                opacity: 0.75;
                text-align: center;

                .texts {
                    line-height: 30px;
                    letter-spacing: 3px;
                    font-size: 16px;
                }

                .imgtitle {
                    font-size: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                }
            }
        }
    }
</style>
<script>
import {
  getOther
} from "../api.js";
export default {
  name: "privacy",
  components: {},
  data() {
    return {
     detail:{}
    };
  },
     beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);

    next();
  },
  created() {
      this.getOthers();
   
  },
  methods: {
    //获取首页数据
    getOthers() {
      getOther({code:'privacy'}).then((res) => {
          this.detail = res.data.Data;
     
      });
    }

   
  },
};
</script>
